import { defineMessages } from 'react-intl-next';

export const messages: {
	close: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	getStarted: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	greeting: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	greeting: {
		id: 'twc.welcome.greetingNoName',
		defaultMessage: 'Hi {name},',
		description: 'Welcome screen greeting without user name',
	},
	title: {
		id: 'twc.welcome.title',
		defaultMessage: 'Welcome to Teamwork Collection',
		description: 'Welcome screen main title',
	},
	description: {
		id: 'twc.welcome.description',
		defaultMessage:
			"You've unlocked a smarter way for your team to connect, collaborate and get more done.",
		description: 'Welcome screen description',
	},
	close: {
		id: 'twc.welcome.close',
		defaultMessage: 'Close',
		description: 'Close button text',
	},
	getStarted: {
		id: 'twc.welcome.getStarted',
		defaultMessage: 'Get started',
		description: 'Primary CTA button text',
	},
});
